import { logError } from "common/error";
import { cancel, delayAnimation } from "common/promises";
class WaitingButtonListen {
    constructor(player) {
        this.player = player;
    }
    waitOn(_button) {
        this.player.lastButtonClicked = Date.now();
    }
}
export class AnnouncementSoundPlayer {
    constructor(sound) {
        this.speed = -1;
        this.onButtonListener = new WaitingButtonListen(this);
        this.lastButtonClicked = null;
        this.ment3LoopPromise = null;
        this.sound = sound;
        this.ment3LoopPromise = cancel.root(async (canceler) => {
            await this.ment3Loop(canceler);
        });
    }
    async ment3Loop(canceler) {
        let prevGap = 9999;
        while (true) {
            canceler.check();
            if (this.lastButtonClicked == null) {
                await delayAnimation(100);
                continue;
            }
            const gap = Date.now() - this.lastButtonClicked;
            if (gap > 3000 && prevGap < 3000) {
                this.sound.play("grandpaSaying3");
            }
            prevGap = gap;
            await delayAnimation(100);
        }
    }
    dispose() {
        var _a;
        (_a = this.ment3LoopPromise) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
    setSpeed(speed) {
        if (this.speed === speed) {
            return;
        }
        const prevSpeed = this.speed;
        this.speed = speed;
        if (prevSpeed < speed) {
            this.play(speed);
        }
    }
    playFinish() {
        this.sound.play("grandpaSaying1");
    }
    play(speed) {
        switch (speed) {
            case 1:
                this.play1().catch(logError);
                break;
        }
    }
    async play1() {
        await delayAnimation(1500);
        this.sound.play("grandpaSaying2");
    }
}
//# sourceMappingURL=announcementPlayer.js.map